import React from "react";
import { NavLink } from "react-router-dom";
import { login } from "../api";
import { toast } from "react-toastify";
import "./Login.css";

class Login extends React.Component {
  state = {
    username: "",
    password: "",
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleFormSubmit = async (event) => {
    try {
      const { setCurrentUser, history } = this.props;
      event.preventDefault();
      const { username, password } = this.state;
      const response = await login(username, password);
      toast.dark(`Welcome to AutoRepair ${username}!`);
      setCurrentUser(response.data);
      history.push("/");
    } catch (e) {
      toast.error(`Wrong details, please try again!`);
    }
  };

  render() {
    const { username, password } = this.state;
    return (
      <main classname="box">
        <form className="loginFormBox" onSubmit={this.handleFormSubmit}>
          {/*     <img src="/images/locationlogo.png" /> */}

          <div className="loginBox">
            <label>Username</label>
            <input
              autocomplete="off"
              type="text"
              name="username"
              value={username}
              onChange={this.handleChange}
              required
            />

            <label>Password</label>
            <input
              autocomplete="off"
              type="password"
              name="password"
              value={password}
              onChange={this.handleChange}
            />

            <div>
              <button>Login</button>
            </div>
          </div>

          <p>—— Or ——</p>

          <NavLink to={"/signup"}>
            <button className="createButton">Create Your Account</button>
          </NavLink>

          <p className="pText">
            By creating or logging into an account you are agreeing with our{" "}
            <NavLink
              style={{ textDecoration: "underline", color: "blue" }}
              to={"/profile/about"}
            >
              Terms Of Service
            </NavLink>{" "}
            and{" "}
            <NavLink
              style={{ textDecoration: "underline", color: "blue" }}
              to={"/profile/privacy"}
            >
              Privacy Statement
            </NavLink>
          </p>
        </form>
      </main>
    );
  }
}

export default Login;
